<div mat-dialog-content>
  <search-menu-auto></search-menu-auto>
</div>